<template>
  <section class="success-stories">
    <div class="head">
      <div class="head-inner">
        <h2>我们客户的成功</h2>
        <p>了解为什么世界领先品牌选择全球电子商务来推动其全球电子商务</p>
        <ul>
          <li
            v-for="item in btnList"
            :key="item.id"
            @click="showInfo = item"
            :class="{ action: item.id === showInfo.id }"
          >
            <template v-if="item['lightIcon']">
              <img :src="item['lightIcon']" alt="" />
              <img :src="item['darkIcon']" alt="" />
            </template>
            <span v-else class="title">{{ item.name }}</span>
          </li>
        </ul>
        <div class="info">
          <div class="left">
            <img class="image" :src="showInfo.listUrl" alt="" />
            <!-- <span class="logo">{{ showInfo.lightIcon }}</span> -->
            <div class="logo">
              <img v-if="showInfo.lightIcon" :src="showInfo.lightIcon" alt="" />
              <span v-else>{{ showInfo.name }}</span>
            </div>
          </div>
          <div class="right">
            <div
              class="ana-luisa"
              v-if="showInfo.casesInfoList && showInfo.casesInfoList.length > 0"
            >
              <img
                class="icon"
                src="../../assets/success-stories/icon-1.svg"
                alt=""
              />
              <p>
                {{ showInfo.casesInfoList[0].content }}
              </p>
              <div class="name">
                <h3>{{ showInfo.casesInfoList[0].author }}</h3>
                <p>{{ showInfo.casesInfoList[0].position }}</p>
              </div>
            </div>
            <div class="st-agni" v-else>
              <span
                style="color: #2f5ad9"
                v-html="decodeURIComponent(showInfo.intro)"
              ></span>
            </div>
            <a class="explore" @click="toDetail(showInfo.id)">阅读更多</a>
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="body-inner">
        <ItemCard v-for="item in cardList" :key="item.id" :itemData="item" />
      </div>
    </div>
    <div class="footer">
      <div class="footer-inner">
        <h2>加入数百个信任我们业务的全球品牌</h2>
        <a class="btn">让我们谈谈</a>
      </div>
    </div>
  </section>
</template>

<script>
import ItemCard from './ItemCard.vue'
import request from '../../utils/request'
export default {
  name: 'SuccessStories',
  components: {
    ItemCard
  },
  data() {
    return {
      showInfo: {},
      btnList: [],
      cardList: []
    }
  },
  mounted() {
    this.getCaseList()
  },
  methods: {
    toDetail(id) {
      this.$router.push({
        name: 'StoryDetail',
        query: { id: id }
      })
    },
    getCaseList() {
      request({
        url: '/cases/listPage',
        params: {},
        data: {
          pageNum: 1,
          pageSize: 10
        },
        method: 'post'
      }).then(res => {
        this.cardList = res.rows

        console.log('res', res)
        //   let intro = '';
        //   this.cardList.forEach((item) => {
        //   if (item.intro) {
        //     try {
        //       item.intro = decodeURIComponent(item.intro);
        //     } catch (e) {
        //       // 解码失败则保持原样
        //     }
        //   }
        // });
        this.btnList = this.cardList.slice(0, 3)
        this.showInfo = this.btnList[0]
      })
    }
  }
}
</script>

<style scoped lang="less">
.success-stories {
  .head {
    padding: 0 5%;
    background-color: #fbfbfc;
    .head-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 50px 0;
      h2 {
        font-size: 48px;
        text-align: center;
      }
      & > p {
        margin: 30px 0;
        text-align: center;
      }
      ul {
        display: flex;
        align-items: center;
        gap: 10px;
        li {
          flex: 1;
          height: 34.12px;
          padding: 15px 35px;
          border-bottom: 3px solid #2a2c2f1a;
          position: relative;
          transition: all 0.5s;
          cursor: pointer;
          text-align: center;
          font-size: 26px;
          color: #999;
          img {
            height: 34.12px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.5s;
            opacity: 1;
            &:last-child {
              opacity: 0;
            }
          }
          &:hover {
            border-color: #2f5ad9;
            color: #666666;
            img:first-child {
              opacity: 0;
            }
            img:last-child {
              opacity: 1;
            }
          }
        }
        .action {
          border-color: #2f5ad9;
          img:first-child {
            opacity: 0;
          }
          img:last-child {
            opacity: 1;
          }
          color: #333333;
        }
      }
      .info {
        height: 355px;
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        align-items: end;
        gap: 40px;
        .left {
          width: 536px;
          height: 355px;
          position: relative;
          .image {
            position: absolute;
            left: 0;
            top: 0;
            width: 536px;
            height: 355px;
            object-fit: cover;
            object-position: center center;
            filter: brightness(50%) contrast(100%) saturate(100%) blur(0px)
              hue-rotate(0deg);
            border-radius: 25px 25px 25px 25px;
          }
          .logo {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            // filter: invert(1);
            font-size: 40px;
            color: #eeeeee;
            img {
              width: 200px;
            }
          }
        }
        .right {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: end;
          gap: 10px;
          .st-agni {
            font-size: 32px;
            font-weight: 700;
            padding-bottom: 40px;
          }
          .ana-luisa {
            flex: 1;
            display: flex;
            flex-direction: column;
            .icon {
              width: 50px;
              height: 50px;
            }
            p {
              margin: 15px 0;
              text-align: left;
              font-size: 18px;
            }
            .name {
              margin-top: auto;
              font-size: 18px;
              h3 {
                color: #2f5ad9;
              }
              p {
                margin: 8px 0;
              }
            }
          }
          .fold {
            padding-bottom: 40px;
            img {
              max-width: 100%;
            }
          }
          .explore {
            font-size: 14px;
            font-weight: 700;
            transition: all 0.5s;
            &::after {
              content: url('../../assets/home/home-right.svg');
              display: inline-block;
              transform: scale(0.8);
              margin-left: 10px;
            }
            &:hover {
              transform: translateX(6px);
              color: #2f5ad9;
            }
          }
        }
      }
    }
  }
  .body {
    padding: 0 5%;
    background-color: #fbfbfc;
    .body-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 70px 0 40px;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 30px;
    }
  }
  .footer {
    padding: 0 5%;
    background-color: #2a2c2f;
    .footer-inner {
      width: 1140px;
      margin: 0 auto;
      padding: 40px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 40px;
      h2 {
        font-size: 36px;
        color: #ffffff;
      }
      a {
        padding: 16px 40px;
        font-size: 18px;
        color: #fff;
        border: 3px solid #2f5ad9;
        border-radius: 30px;
        background-color: #2f5ad9;
        &:hover {
          background-color: #fff;
          color: #2f5ad9;
        }
      }
    }
  }
}
</style>
